import React from 'react';
import Moment from 'moment';
import PlainCRUD from 'components/PlainCRUD';
import {
  getPresupuestosDeIngresos,
  postPresupuestoDeIngresos,
  patchPresupuestoDeIngresos,
  deletePresupuestoDeIngresos,
  baseURI,
} from 'api/catalogos/presupuestosDeIngresos';
import { getClases } from 'api/catalogos/clases';
import toCurrency from 'utils/toCurrency';

// eslint-disable-next-line react/prop-types
const PresupuestoDeIngresos = ({ permission }) => (
  <PlainCRUD
    title="Presupuesto de Ingresos"
    permission={permission}
    tableProps={{ baseURI, allowImport: true }}
    get={getPresupuestosDeIngresos}
    post={postPresupuestoDeIngresos}
    patch={patchPresupuestoDeIngresos}
    delete={deletePresupuestoDeIngresos}
    fields={[
      {
        name: 'anio_fiscal',
        label: 'Año Fiscal',
        colWidth: 150,
        required: true,
        type: 'date.year',
      },
      {
        name: 'importe',
        label: 'Importe',
        colWidth: 150,
        required: true,
        type: 'decimal',
        render: (item) => toCurrency(item),
        decimal: true,
        align: 'right',
      },
      {
        name: 'clase',
        label: 'Clase',
        // colWidth: 350,
        required: true,
        type: 'select',
        render: (item) => item?.denominacion,
        useCatalog: true,
      },
    ]}
    catalogs={[
      {
        permission: 'clase',
        get: getClases,
        formItemName: 'clase',
      },
    ]}
    valuesToFormFormatter={({ anio_fiscal, ...values }) => ({
      anio_fiscal: new Moment([anio_fiscal, 1, 1]),
      ...values,
    })}
    withoutState
  />
);

export default PresupuestoDeIngresos;
